import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const main: ThemeUICSSObject = {
  width: '100vw',
  height: '100vh',
  overflow: 'auto',
  backgroundColor: 'printView.main.backgroundColor',

  '.print__sheet': {
    backgroundColor: 'printView.main.page.backgroundColor',
    border: '1px solid',
    borderColor: 'printView.main.page.borderColor',
    my: 4,
    mx: 'auto',
    p: '15mm',
    width: '240mm',
  },

  '@media print': {
    backgroundColor: 'transparent',
    overflow: 'unset',

    '.print__sheet': {
      backgroundColor: 'transparent',
      border: 'none',
      m: 0,
      p: 0,
      width: '210mm',
    },
  },
};

export default main;
